import { render, staticRenderFns } from "./Resources.vue?vue&type=template&id=5196e8b0"
import script from "./Resources.vue?vue&type=script&setup=true&lang=js"
export * from "./Resources.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports